<div class="extended-fab-button-tool">
    <button mat-icon-button color="primary" class="content" [attr.data-test-id]="testId">
        <mat-icon>{{icon}}</mat-icon>
        <span class="extended-fab-button__text"><ng-content></ng-content></span>
    </button>
</div>